
import { combineReducers } from "redux";
import {
  CREATE_POLICY_FEATURE_END,
  CREATE_POLICY_FEATURE_RECIEVES,
  CREATE_POLICY_FEATURE_START,
  UPDATE_POLICY_FEATURE_END,
  UPDATE_POLICY_FEATURE_RECIEVES,
  UPDATE_POLICY_FEATURE_START,
  DELETE_POLICY_FEATURE_END,
  DELETE_POLICY_FEATURE_RECIEVES,
  DELETE_POLICY_FEATURE_START,
  FETCH_POLICY_FEATURES_END,
  FETCH_POLICY_FEATURES_RECIEVES,
  FETCH_POLICY_FEATURES_START
  } from "./action-types";


export const CreatePolicyFeature = (
	state: { loading: boolean; data: any } = {
		loading: false,
		data: { data: [] },
	},
	{ type, data, error }
) => {
	switch (type) {
		case CREATE_POLICY_FEATURE_START: {
			return {
				loading: true,
				data: [],
				error: "",
			};
		}
		case CREATE_POLICY_FEATURE_RECIEVES: {
			return {
				loading: false,
				data,
				error: "",
			};
		}
		case CREATE_POLICY_FEATURE_END: {
			return {
				loading: false,
				data: [],
				error,
			};
		}
		default:
			return state;
	}
};

export const GetPolicyFeatures = (
	state: { loading: boolean; data: any } = {
		loading: false,
		data: { data: [] },
	},
	{ type, data, error }
) => {
	switch (type) {
		case FETCH_POLICY_FEATURES_START: {
			return {
				loading: true,
				data: [],
				error: "",
			};
		}
		case FETCH_POLICY_FEATURES_RECIEVES: {
			return {
				loading: false,
				data,
				error: "",
			};
		}
		case FETCH_POLICY_FEATURES_END: {
			return {
				loading: false,
				data: [],
				error,
			};
		}
		default:
			return state;
	}
};

export const DeletePolicyFeature = (
	state: { loading: boolean; data: any } = {
		loading: false,
		data: { data: [] },
	},
	{ type, data, error }
) => {
	switch (type) {
		case DELETE_POLICY_FEATURE_START: {
			return {
				loading: true,
				data: [],
				error: "",
			};
		}
		case DELETE_POLICY_FEATURE_RECIEVES: {
			return {
				loading: false,
				data,
				error: "",
			};
		}
		case DELETE_POLICY_FEATURE_END: {
			return {
				loading: false,
				data: [],
				error,
			};
		}
		default:
			return state;
	}
};

export const UpdatePolicyFeature = (
	state: { loading: boolean; data: any } = {
		loading: false,
		data: { data: [] },
	},
	{ type, data, error }
) => {
	switch (type) {
		case UPDATE_POLICY_FEATURE_START: {
			return {
				loading: true,
				data: [],
				error: "",
			};
		}
		case UPDATE_POLICY_FEATURE_RECIEVES: {
			return {
				loading: false,
				data,
				error: "",
			};
		}
		case UPDATE_POLICY_FEATURE_END: {
			return {
				loading: false,
				data: [],
				error,
			};
		}
		default:
			return state;
	}
};

export default combineReducers({
  CreatePolicyFeature,
	GetPolicyFeatures,
	DeletePolicyFeature,
	UpdatePolicyFeature
});